module.exports = __webpack_public_path__ + "img/buzou2.44b66fc5.png";